export const lyrics=[
	{
		title: "Last Resort   --Eagles",
		lyrics: "[Verse 1]\n\
She came from Providence\n\
The one in Rhode Island\n\
Where the old world shadows hang\n\
Heavy in the air\n\
She packed her hopes and dreams\n\
Like a refugee\n\
Just as her father came across the sea\n\
\n\
\
\
[Verse 2]\n\
She heard about a place people were smiling\n\
They spoke about the red man's way\n\
And how they loved the land\n\
And they came from everywhere\n\
To the Great Divide\n\
Seeking a place to stand\n\
Or a place to hide\n\
\n\
[Verse 3]\n\
Down in the crowded bars\n\
Out for a good time\n\
Can't wait to tell you all\n\
What it's like up there\n\
And they called it paradise\n\
I don't know why\n\
Somebody laid the mountains low\n\
While the town got high\n\
\n\
[Verse 4]\n\
Then the chilly winds blew down\n\
Across the desert\n\
Through the canyons of the coast\n\
To the Malibu\n\
Where the pretty people play\n\
Hungry for power\n\
To light their neon way\n\
And give them things to do\n\
\n\
[Verse 5]\n\
Some rich men came and raped the land\n\
Nobody caught them\n\
Put up a bunch of ugly boxes\n\
And Jesus people bought them\n\
And they called it paradise\n\
The place to be\n\
They watched the hazy sun, sinking in the sea\n\
\n\
[Verse 6]\n\
You can leave it all behind\n\
And sail to Lahaina\n\
Just like the missionaries did, so many years ago\n\
They even brought a neon sign: \"Jesus is coming\"\n\
Brought the white man's burden down\n\
Brought the white man's reign\n\
\n\
[Verse 7]\n\
Who will provide the grand design?\n\
What is yours and what is mine?\n\
Because there is no more new frontier\n\
We have got to make it here\n\
We satisfy our endless needs and\n\
Justify our bloody deeds\n\
In the name of destiny\n\
And in the name of God\n\
\n\
[Verse 8]\n\
And you can see them there\n\
On Sunday morning\n\
Stand up and sing about\n\
What it's like up there\n\
They call it paradise\n\
I don't know why\n\
You call someplace paradise\n\
Kiss it goodbye"
	},

	{
		title: 'Numb   --Linkin Park',
		lyrics: "[Verse 1: Chester Bennington]\n\
I'm tired of being what you want me to be\n\
Feeling so faithless, lost under the surface\n\
I don't know what you're expecting of me\n\
Put under the pressure of walking in your shoes\n\
\n\
[Pre-Chorus: Chester Bennington & Mike Shinoda]\n\
Caught in the undertow, just caught in the undertow\n\
Every step that I take is another mistake to you\n\
Caught in the undertow, just caught in the undertow\n\
\n\
[Chorus: Chester Bennington]\n\
I've become so numb, I can't feel you there\n\
Become so tired, so much more aware\n\
I'm becoming this, all I want to do\n\
Is be more like me and be less like you\n\
\n\
[Verse 2: Chester Bennington]\n\
Can't you see that you're smothering me?\n\
Holding too tightly, afraid to lose control\n\
'Cause everything that you thought I would be\n\
Has fallen apart, right in front of you\n\
\n\
[Pre-Chorus: Chester Bennington & Mike Shinoda]\n\
Caught in the undertow, just caught in the undertow\n\
Every step that I take is another mistake to you\n\
Caught in the undertow, just caught in the undertow\n\
And every second I waste is more than I can take\n\
[Chorus: Chester Bennington]\n\
I've become so numb, I can't feel you there\n\
Become so tired, so much more aware\n\
I'm becoming this, all I want to do\n\
Is be more like me and be less like you\n\
\n\
[Bridge: Chester Bennington]\n\
And I know I may end up failing, too\n\
But I know you were just like me\n\
With someone disappointed in you\n\
\n\
[Chorus: Chester Bennington]\n\
I've become so numb, I can't feel you there\n\
Become so tired, so much more aware\n\
I'm becoming this, all I want to do\n\
Is be more like me and be less like you\n\
\n\
[Outro: Chester Bennington]\n\
I've become so numb, I can't feel you there\n\
I'm tired of being what you want me to be\n\
I've become so numb, I can't feel you there\n\
I'm tired of being what you want me to be"
	},

	{
		title: 'You Know My Name   --Chris Cornell' ,
		lyrics: "[Verse 1]\n\
If you take a life do you know what you'll give?\n\
Odds are, you won't like what it is\n\
When the storm arrives, would you be seen with me?\n\
By the merciless eyes I've deceived?\n\
\n\
[Pre-Chorus 1]\n\
I've seen angels fall from blinding heights\n\
But you yourself are nothing so divine\n\
Just next in line\n\
\n\
[Chorus]\n\
Arm yourself because no one else here will save you\n\
The odds will betray you\n\
And I will replace you\n\
You can't deny the prize, it may never fulfill you\n\
It longs to kill you\n\
Are you willing to die?\n\
The coldest blood runs through my veins\n\
You know my name\n\
\n\
[Verse 2]\n\
If you come inside things will not be the same\n\
When you return to the night\n\
And if you think you've won\n\
You never saw me change\n\
The game that we have been playing\n\
[Pre-Chorus 2]\n\
I've seen this diamond cut through harder men\n\
Than you yourself, but if you must pretend\n\
You may meet your end\n\
\n\
[Chorus]\n\
Arm yourself because no one else here will save you\n\
The odds will betray you\n\
And I will replace you\n\
You can't deny the prize, it may never fulfill you\n\
It longs to kill you\n\
Are you willing to die?\n\
The coldest blood runs through my veins\n\
\n\
[Bridge]\n\
Try to hide your hand\n\
Forget how to feel\n\
(Forget how to feel)\n\
Life is gone with just a spin of the wheel\n\
(Spin of the wheel)\n\
\n\
[Chorus]\n\
Arm yourself because no one else here will save you\n\
The odds will betray you\n\
And I will replace you\n\
You can't deny the prize, it may never fulfill you\n\
It longs to kill you\n\
Are you willing to die?\n\
The coldest blood runs through my veins\n\
You know my name\n\
\n\
[Outro]\n\
You know my name\n\
You know my name\n\
You know my name\n\
You know my name\n\
You know my name\n\
You know my name"
	},

	{
		title: 'Nobody Can Save Me   --Linkin Park' ,
		lyrics: "[Verse 1]\n\
I'm dancing with my demons\n\
I'm hanging off the edge\n\
Storm clouds gather beneath me\n\
Waves break above my head\n\
Headfirst hallucination\n\
\n\
[Pre-Chorus 1]\n\
I wanna fall wide awake now\n\
You tell me it's alright\n\
Tell me I'm forgiven, tonight\n\
\n\
[Chorus]\n\
But nobody can save me now\n\
I'm holding up a light\n\
I'm chasing out the darkness inside\n\
'Cause nobody can save me\n\
\n\
[Verse 2]\n\
Stared into this illusion\n\
For answers yet to come\n\
I chose a false solution\n\
But nobody proved me wrong\n\
Headfirst hallucination\n\
\n\
[Pre-Chorus 2]\n\
I wanna fall wide awake\n\
Watch the ground giving way now\n\
You tell me it's alright\n\
Tell me I'm forgiven, tonight\n\
[Chorus]\n\
But nobody can save me now\n\
I'm holding up a light\n\
I'm chasing out the darkness inside\n\
'Cause nobody can save me\n\
\n\
[Bridge]\n\
Been searching somewhere out there\n\
For what's been missing right here (I wanna fall wide awake now)\n\
I've been searching somewhere out there\n\
For what's been missing right here (I wanna fall wide awake now)\n\
I wanna fall wide awake now\n\
So tell me it's alright\n\
Tell me I'm forgiven, tonight\n\
\n\
[Outro]\n\
And only I can save me now\n\
I'm holding up a light\n\
Chasing out the darkness inside\n\
And I don't wanna let you down\n\
But only I can save me!\n\
\n\
Been searching somewhere out there\n\
For what's been missing right here"
	},

	{
		title: 'A Place For My Head   --Linkin Park' ,
		lyrics: "[Verse 1: Mike Shinoda]\n\
I watch how the moon sits in the sky in the dark night\n\
Shining with the light from the sun\n\
The sun doesn't give light to the moon assuming\n\
The moon's gonna owe it one\n\
It makes me think of how you act to me\n\
You do favors, then rapidly\n\
Just turn around and start askin' me about\n\
Things that you want back from me\n\
\n\
[Pre-Chorus: Mike Shinoda]\n\
I'm sick of the tension, sick of the hunger\n\
Sick of you actin' like I owe you this\n\
Find another place to feed your greed\n\
While I find a place to rest\n\
\n\
[Chorus: Chester Bennington & Mike Shinoda]\n\
I wanna be in another place\n\
I hate when you say you don't understand\n\
(You'll see it's not meant to be)\n\
I wanna be in the energy, not with the enemy\n\
A place for my head\n\
\n\
[Verse 2: Mike Shinoda]\n\
Maybe someday, I'll be just like you and\n\
Step on people like you do and\n\
Run away all the people I thought I knew\n\
I remember back then who you were\n\
You used to be calm, used to be strong\n\
Used to be generous, but you shoulda known\n\
That you'd wear out your welcome\n\
And now, you see how quiet it is all alone\n\
[Pre-Chorus: Mike Shinoda]\n\
I'm so sick of the tension, sick of the hunger\n\
Sick of you actin' like I owe you this\n\
Find another place to feed your greed\n\
While I find a place to rest\n\
I'm so sick of the tension, sick of the hunger\n\
Sick of you actin' like I owe you this\n\
Find another place to feed your greed\n\
While I find a place to rest\n\
\n\
[Chorus: Chester Bennington & Mike Shinoda]\n\
I wanna be in another place\n\
I hate when you say you don't understand\n\
(You'll see it's not meant to be)\n\
I wanna be in the energy, not with the enemy\n\
A place for my head\n\
\n\
[Interlude: Chester Bennington]\n\
You try to take the best of me, go away\n\
You try to take the best of me, go away\n\
You try to take the best of me, go away\n\
You try to take the best of me, go away\n\
\n\
[Bridge: Chester Bennington]\n\
You try to take the best of me, go away\n\
You try to take the best of me, go away\n\
You try to take the best of me, go away\n\
You try to take the best of me, go away\n\
\n\
[Chorus: Chester Bennington & Mike Shinoda]\n\
I wanna be in another place\n\
I hate when you say you don't understand\n\
(You'll see it's not meant to be)\n\
I wanna be in the energy, not with the enemy\n\
A place for my head\n\
\n\
[Outro: Chester Bennington & Mike Shinoda]\n\
Stay away\n\
I am so sick of the tension, sick of the hunger (Sick)\n\
Sick of you actin' like I owe you this\n\
Find another place to feed your greed (Go)\n\
While I find a place to rest\n\
I'm so sick of the tension, sick of the hunger (Why?)\n\
Sick of you actin' like I owe you this\n\
Find another place to feed your greed (Stay away from me)\n\
While I find a place to rest"
	},

	{
		title: 'Start Again   --One Republic' ,
		lyrics: "[Chorus: Ryan Tedder]\n\
Can't I just turn back the clock?\n\
Forgive my sins\n\
I just wanna roll my sleeves up\n\
And start again\n\
I know that I messed it up\n\
Time and time again\n\
I just wanna roll my sleeves up\n\
And start again\n\
\n\
[Verse 1: Ryan Tedder]\n\
I was switchin' up the lanes\n\
Steppin' out the frame I'm in\n\
I was pulling on the reins\n\
Sick of all the same happenin'\n\
I swear I was looking for disaster\n\
Mixed with a bottle of gin\n\
And just because I come home after\n\
Doesn't mean you'll take me in\n\
\n\
[Pre-Chorus: Ryan Tedder]\n\
You see my world is spinning like there's nothing below\n\
You see my world is feeling like it just might explode\n\
And yes I know it's hard to take it backwards from my mind\n\
I need to get it right, need to see some light come in\n\
[Chorus: Ryan Tedder]\n\
Can't I just turn back the clock?\n\
Forgive my sins\n\
I just wanna roll my sleeves up\n\
And start again\n\
I know that I messed it up\n\
Time and time again\n\
I just wanna roll my sleeves up\n\
And start again\n\
\n\
[Verse 2: Logic]\n\
Feelin' like maybe I'm unappreciated\n\
Like my presence in your life has been alleviated\n\
I feel like everything I've done before is different now\n\
But I can see clearer than ever from a distance now\n\
Every day I do it, I been goin' through it\n\
But you never knew it 'cause I never showed you\n\
You gave me the world, so I feel I owed you\n\
I been lookin' through the mirror and that's the old you\n\
I'ma get it right now, don't know how\n\
But I promise that we're gonna make it somehow\n\
I'm all in, it's from the heart again\n\
Open up your mind and maybe we could start again\n\
\n\
[Chorus: Ryan Tedder]\n\
Can't I just turn back the clock?\n\
Forgive my sins\n\
I just wanna roll my sleeves up\n\
And start again\n\
I know that I messed it up\n\
Time and time again\n\
I just wanna roll my sleeves up\n\
And start again\n\
[Refrain: Ryan Tedder]\n\
Oh-oh-oh, oh-oh-oh\n\
Oh-oh-oh, oh-oh-oh\n\
\n\
[Outro: Ryan Tedder]\n\
And yes I know it's hard to take it backwards from my mind\n\
I need to get it right, need to see some light come in\n\
Can't I just turn back the clock?\n\
Forgive my sins\n\
I just wanna roll my sleeves up\n\
And start again"
	},

	{
		title: 'Waiting For The End   --Linkin Park' ,
		lyrics: "[Intro: Mike Shinoda]\n\
This is not the end, this is not the beginning\n\
Just a voice like a riot rocking every revision\n\
But you listen to the tone and the violent rhythm\n\
And though the words sound steady, something empty's within them\n\
We say yeah, with fists flying up in the air\n\
Like we're holding onto something that's invisible there\n\
'Cause we're living at the mercy of the pain and the fear\n\
Until we dead it, forget it, let it all disappear\n\
\n\
[Verse 1: Chester Bennington]\n\
Waiting for the end to come\n\
Wishing I had strength to stand\n\
This is not what I had planned\n\
It's out of my control\n\
\n\
[Verse 2: Chester Bennington]\n\
Flying at the speed of light\n\
Thoughts were spinning in my head\n\
So many things were left unsaid\n\
It's hard to let you go\n\
\n\
[Chorus: Chester Bennington]\n\
I know what it takes to move on\n\
I know how it feels to lie\n\
All I want to do is trade this life for something new\n\
Holding on to what I haven't got\n\
[Verse 3: Chester Bennington]\n\
Sitting in an empty room\n\
Trying to forget the past\n\
This was never meant to last\n\
I wish it wasn't so\n\
\n\
[Chorus: Chester Bennington]\n\
I know what it takes to move on\n\
I know how it feels to lie\n\
All I want to do is trade this life for something new\n\
Holding on to what I haven't got\n\
\n\
[Bridge: Mike Shinoda]\n\
What was left when that fire was gone?\n\
I thought it felt right, but that right was wrong\n\
All caught up in the eye of the storm\n\
And trying to figure out what it's like moving on\n\
And I don't even know what kind of things I said\n\
My mouth kept moving and my mind went dead\n\
So, I'm picking up the pieces now, where to begin\n\
The hardest part of ending is starting again\n\
\n\
[Outro: Chester Bennington & Mike Shinoda]\n\
All I want to do is trade this life for something new\n\
Holding on to what I haven't got\n\
This is not the end, this is not the beginning\n\
Just a voice like a riot, rocking every revision\n\
I'm holding on to what I haven't got\n\
But you listen to the tone and the violent rhythm\n\
Though the words sound steady\n\
Something empty's within them\n\
We say yeah, with fists flying up in the air\n\
Like we're holding onto something that's invisible there\n\
Holding on to what I haven't got\n\
'Cause we're living at the mercy of the pain and the fear\n\
Until we get it, forget it, let it all disappear"
	},

	{
		title: 'Lost In The Echo   --Linkin Park' ,
		lyrics: "[Intro: Mike Shinoda]\n\
Yeah, yo\n\
\n\
[Verse 1: Mike Shinoda]\n\
You were that foundation\n\
Never gonna be another one, no\n\
I followed, so taken\n\
So conditioned, I could never let go\n\
Then sorrow, then sickness\n\
Then the shock when you flip it on me\n\
So hollow, so vicious\n\
So afraid, I couldn't let myself see\n\
That I could never be held\n\
Back or up, no, I hold myself\n\
Check the rep, yep, you know mine well\n\
Forget the rest, let them know my Hell\n\
There and back, yet my soul ain't sell\n\
Kept respect up, the best they fell\n\
Let the rest be the tale they tell\n\
That I was there, saying\n\
\n\
[Chorus: Chester Bennington]\n\
In these promises broken, deep below\n\
Each word gets lost in the echo\n\
So, one last lie I can see through\n\
This time, I finally let you go, go, go\n\
[Verse 2: Mike Shinoda]\n\
Test my will, test my heart\n\
Let me tell you how the odds gonna stack up\n\
Y'all go hard, I go smart\n\
How's that working out for y'all in the back, huh?\n\
I've seen that, frustration\n\
Been crossed and lost and told no\n\
And I've come back, unshaken\n\
Let down and lived and let go\n\
So, you can let it be known\n\
I don't hold back, I hold my own\n\
I can't be mapped, I can't be cloned\n\
I can't C-flat, it ain't my tone\n\
I can't fall back, I came too far\n\
Hold myself up and love my scars\n\
Let the bells ring wherever they are\n\
'Cause I was there, saying\n\
\n\
[Chorus: Chester Bennington]\n\
In these promises broken, deep below\n\
Each word gets lost in the echo\n\
So, one last lie I can see through\n\
This time, I finally let you go!\n\
\n\
[Bridge: Mike Shinoda]\n\
No, you can tell 'em all now\n\
I don't back up, I don't back down\n\
I don't fold up and I don't bow\n\
I don't roll over, don't know how\n\
I don't care where the enemies are\n\
Can't be stopped, all I know, go hard\n\
Won't forget how I got this far\n\
For every time, saying\n\
[Chorus: Chester Bennington]\n\
In these promises broken deep below\n\
Each word gets lost in the echo\n\
So, one last lie I can see through\n\
This time, I finally let you go, go, go\n\
Go, go, go, go"
	},

	{
		title: 'I Was Never There   --Weeknd' ,
		lyrics: "[Verse]\n\
What makes a grown man wanna cry?\n\
(Cry, cry, cry, cry)\n\
What makes him wanna take his life?\n\
(Yeah)\n\
His happiness is never real\n\
(Real, real, real, real)\n\
And mindless sex is how he feels, ooh, he heals\n\
\n\
[Chorus]\n\
When it's time, when it's time, when it's time\n\
It won't matter (it don't matter)\n\
It won't matter (matter)\n\
When it's time, when it's time, when it's time (time, it's time, babe)\n\
It won't matter (it won't matter, babe)\n\
It won't matter (ya)\n\
It was like he was never there\n\
(It was like he was never there)\n\
It was like he was gone in thin air, oh\n\
When it's time, when it's time, when it's time, oh, baby\n\
It won't matter (It won't matter, baby)\n\
It won't matter\n\
\n\
[Post-Chorus]\n\
When it's time, when it's time, when it's time\n\
It won't matter\n\
It won't matter\n\
When it's time, when it's time, when it's time\n\
It won't matter\n\
It won't matter\n\
It was like he was never there\n\
It was like he was gone in thin air\n\
When it's time, when it's time, when it's time\n\
It won't matter, it won't matter\n\
[Interlude]\n\
When it's time, when it's time, when it's time\n\
It won't matter, it won't matter\n\
When it's time, when it's time, when it's time\n\
It won't matter, it won't matter\n\
\n\
[Bridge]\n\
Ooh, now I know what love is\n\
And I know it ain't you for sure\n\
You'd rather something toxic\n\
So, I poison myself again, again\n\
'Til I feel nothing\n\
In my soul (in my soul)\n\
I'm on the edge of something breaking\n\
I feel my mind is slowly fadin'\n\
If I keep going, I won't make it\n\
If I keep going, I won't make it\n\
\n\
[Outro]\n\
And it's all because of you\n\
It's all because of you\n\
It's all because of you\n\
It's all because of you\n\
Woah, woah\n\
Don't you, baby, hey\n\
It won't matter, baby\n\
Don't you know?\n\
Don't you know?\n\
Ooh, no\n\
"
	},

	{
		title: "What We Don't Know   --Linkin Park" ,
		lyrics: "If everything would just stop\n\
Then maybe I could collect my thoughts\n\
If everything would stand still\n\
I could've hidden how lost I feel\n\
\n\
I should've said what I hear\n\
I should've let myself fear\n\
I should've made myself clear\n\
\n\
So this is how we fall apart\n\
This is how the ending starts\n\
And when we find we've lost our mark\n\
We fake what we don't know\n\
\n\
I never asked to let go\n\
I never thought I could sink so low\n\
I never let myself down\n\
Until the second I did right now\n\
\n\
I should've said what I hear\n\
I should've let myself fear\n\
I should've made myself clear\n\
\n\
So this is how we fall apart\n\
This is how the ending starts\n\
And when we find we've lost our mark\n\
We fake what we don't know\n\
\n\
This is how we fall apart\n\
This is how the ending starts\n\
'Cause when our heads betray our hearts\n\
We fake what we don't know\n\
\n\
'Cause all we are is everything we've done\n\
All we are is how quickly we run\n\
And all we are\n\
We are\n\
\n\
This is how we fall apart\n\
But this is how beginnings start\n\
'Cause when our heads betray our hearts\n\
We fake what we don't know\n\
\n\
And if our doubt begins again\n\
The answers find us in the end\n\
So in the meantime we'll pretend\n\
And fake what we don't know\n\
\n\
This is how we fall apart\n\
But this is how beginnings start\n\
'Cause when our heads betray our hearts\n\
We fake what we don't know\n\
\n\
And if our doubt begins again\n\
The answers find us in the end\n\
So in the meantime we'll pretend\n\
And fake what we don't know\n\
"
	},

	{
		title: 'Twenty Eight   --Weeknd' ,
		lyrics: "[Verse 1]\n\
This house is not a home to you\n\
But you decide to go ahead and lay down, lay down\n\
There are no words to describe the depth of your indifference\n\
'Cause I see you're here to stay\n\
Should've known to pick my fate\n\
\n\
[Chorus]\n\
I'm so wrong, I'm so wrong\n\
(To let you in my)\n\
To let you in my home\n\
(Now you know where I sleep)\n\
Now you know where I sleep\n\
(Never felt so damn weak)\n\
\n\
[Verse 2]\n\
Hey there, lonely girl\n\
Did you have to tell your friends\n\
About the way I got you screaming my name?\n\
Did you have to tell the world?\n\
Now your girls all wanna fuck\n\
Girl you could've been the one\n\
Gotta change my number twice a month\n\
When you could have simply kept it on the down low\n\
\n\
[Chorus]\n\
I'm so wrong, I'm so wrong\n\
(To let you in my)\n\
To let you in my home\n\
(Now you know where I sleep)\n\
Now you know where I sleep\n\
(Never felt so damn weak)\n\
[Verse 3]\n\
Baby if I knew you'd be living in my sheets\n\
I wouldn't have shown you any love\n\
I would have left you in the club\n\
You said you don't belong\n\
You keep saying there's no one\n\
And there's no where to go\n\
But who keeps calling on your phone?\n\
I'm so wrong, I'm so wrong, I'm so wrong\n\
\n\
[Chorus]\n\
I'm so wrong, I'm so wrong\n\
(To let you in my)\n\
To let you in my home\n\
(Now you know where I sleep)\n\
Now you know where I sleep\n\
(Never felt so damn weak)\n\
I'm so wrong, I'm so wrong\n\
(To let you in my)\n\
To let you in my home\n\
(Now you know where I sleep)\n\
Now you know where I sleep\n\
(Never felt so damn weak)\n\
\n\
[Outro]\n\
Girl, if your man call your phone again\n\
Girl, if your man call your phone again\n\
"
	},

	{
		title: 'Faith   --Weeknd' ,
		lyrics: "[Intro]\n\
No, no, no, no, no-no\n\
Ooh\n\
No, no, no, no, no-no\n\
Ooh\n\
\n\
[Verse 1]\n\
Light a blunt up with the flame\n\
Put that cocaine on a plate\n\
Molly with the purple rain\n\
'Cause I lost my faith\n\
So I cut away the pain, uh\n\
Got it swimming in my veins\n\
Now my mind is outta place, yeah, uh\n\
'Cause I lost my faith\n\
\n\
[Chorus]\n\
And I feel everything\n\
I feel everything from my body to my soul\n\
No, no\n\
Well, I feel everything\n\
When I'm coming down is the most I feel alone\n\
No, no\n\
\n\
[Post-Chorus]\n\
I've been sober for a year, now it's time for me\n\
To go back to my old ways, don't you cry for me\n\
Thought I'd be a better man, but I lied to me and to you\n\
[Verse 2]\n\
I take half a Xan' and I still stay awake\n\
All my demons wanna pull me to my grave\n\
I choose Vegas if they offer Heaven's gate\n\
I tried to love, but you know I'd never stay\n\
I'd never stay\n\
But if I OD, I want you to OD right beside me\n\
I want you to follow right behind me\n\
I want you to hold me while I'm smiling\n\
While I'm dying\n\
And if you know me\n\
When I go missing, you know where to find me\n\
Driving down the boulevard is blinding\n\
Always blinded by the desert lights and\n\
I'm alive when\n\
\n\
[Chorus]\n\
I feel everything\n\
I feel everything from my body to my soul\n\
No, no\n\
Girl, I feel everything\n\
When I'm coming down is the most I feel alone\n\
No, no\n\
\n\
[Bridge]\n\
I lost my faith\n\
I'm losing my religion every day\n\
Time hasn't been kind to me, I pray\n\
When I look inside the mirror and see someone I love\n\
Oh, someone I love\n\
Faith\n\
I'm losing my religion every day\n\
Time hasn't been kind to me, I pray\n\
When I look inside the mirror and see someone I love\n\
Oh, someone I love\n\
[Outro]\n\
I ended up in the back of a flashing car\n\
With the city shining on my face\n\
The lights are blinding me again\n\
I ended up in the back of a flashing car\n\
With the city shining on my face\n\
The lights are blinding me again\n\
I ended up (I ended up), in the back of a flashing car (Back of a flashing car)\n\
"
	},

	{
		title: 'Papercut   --Linkin Park' ,
		lyrics: "[Verse 1: Mike Shinoda]\n\
Why does it feel like night today?\n\
Something in here's not right today\n\
Why am I so uptight today?\n\
Paranoia's all I got left\n\
I don't know what stressed me first\n\
Or how the pressure was fed\n\
But I know just what it feels like\n\
To have a voice in the back of my head\n\
\n\
[Pre-Chorus: Mike Shinoda]\n\
Like a face that I hold inside\n\
A face that awakes when I close my eyes\n\
A face that watches every time I lie\n\
A face that laughs every time I fall\n\
(And watches everything)\n\
So I know that when it's time to sink or swim\n\
That the face inside is here in me\n\
Right underneath my skin\n\
\n\
[Chorus: Chester Bennington & Mike Shinoda]\n\
It's like I'm paranoid, looking over my back\n\
It's like a whirlwind inside of my head\n\
It's like I can't stop what I'm hearing within\n\
It's like the face inside is right beneath my skin\n\
[Verse 2: Mike Shinoda]\n\
I know I've got a face in me\n\
Points out all my mistakes to me\n\
You've got a face on the inside, too\n\
And your paranoia's probably worse\n\
I don't know what set me off first\n\
But I know what I can't stand\n\
Everybody acts like the fact of the matter\n\
Is I can't add up to what you can\n\
\n\
[Pre-Chorus: Mike Shinoda]\n\
But everybody has a face that they hold inside\n\
A face that awakes when I close my eyes\n\
A face that watches every time they lie\n\
A face that laughs every time they fall\n\
(And watches everything)\n\
So you know that when it's time to sink or swim\n\
That the face inside is watching you, too\n\
Right inside your skin\n\
\n\
[Chorus: Chester Bennington & Mike Shinoda]\n\
It's like I'm paranoid, looking over my back\n\
It's like a whirlwind inside of my head\n\
It's like I can't stop what I'm hearing within\n\
It's like the face inside is right beneath the skin\n\
It's like I'm paranoid, looking over my back\n\
It's like a whirlwind inside of my head\n\
It's like I can't stop what I'm hearing within\n\
It's like the face inside is right beneath my skin\n\
[Refrain: Mike Shinoda]\n\
The face inside is right beneath your skin\n\
The face inside is right beneath your skin\n\
The face inside is right beneath your skin\n\
\n\
[Bridge: Chester Bennington]\n\
The sun goes down\n\
I feel the light betray me\n\
The sun goes down\n\
I feel the light betray me\n\
\n\
[Chorus: Chester Bennington & Mike Shinoda]\n\
(The sun) It's like I'm paranoid, looking over my back\n\
It's like a whirlwind inside of my head\n\
It's like I can't stop what I'm hearing within\n\
It's like the face inside is right beneath the skin (I feel the light betray me)\n\
(The sun) It's like I'm paranoid, looking over my back\n\
It's like a whirlwind inside of my head\n\
It's like I can't stop what I'm hearing within\n\
It's like I can't stop what I'm hearing within (I feel the light betray me)\n\
It's like I can't stop what I'm hearing within\n\
(It's like) It's like the face inside is right beneath my skin\n\
"
	},

	{
		title: 'The Town   --Weeknd' ,
		lyrics: "[Hook]\n\
You did many things\n\
That I liked, that I liked\n\
And you like diamond rings\n\
I can provide, I can provide for you\n\
You made me feel so good\n\
Before I left\n\
On the road\n\
And you deserve your name\n\
On a crown, on a throne\n\
You did many things\n\
That I liked, that I liked\n\
And you like diamond rings\n\
I can provide, I can provide for you\n\
You made me feel so good\n\
Before I left\n\
On the road\n\
And you deserve your name\n\
On a crown, on a throne\n\
\n\
[Verse 1]\n\
I haven't been around my town in a long while\n\
I apologize, but I\n\
I've been trying to get this money like I got a couple kids who rely\n\
On me\n\
But I remember on the bathroom floor\n\
'Fore I went on tour\n\
Like you said we couldn't do it again\n\
Cause you had a thing with some other man\n\
You said it was love\n\
And you said you were lost\n\
Then you wished me good luck\n\
To find somebody to love\n\
But, oooh\n\
Now I've heard that you're single\n\
And uh huh, I'll give you something to live for\n\
Yes, I will\n\
[Verse 2]\n\
Honey, please\n\
You never thought you'd ever see my face again\n\
But your love just swayed the lies\n\
When he stared into your eyes\n\
He just might be too good for you\n\
You're almost dead to him\n\
You're sleeping with a frozen heart\n\
Well baby girl it's over now\n\
And you can always count on me\n\
Your unshackled boy, unrestrained to touch\n\
So immune to love\n\
And it feels so priceless to me\n\
That you're always free\n\
That you'll take me in\n\
Now I'm everything, your everything\n\
I bet you'll take me in\n\
I know you'll take me in now\n\
The same place I left you in (we)\n\
I bet you'll take me in\n\
I know you'll take me in, I know you'll take me in\n\
The same place I left you in\n\
\n\
[Breakdown]\n\
We\n\
Who?\n\
Oooh...\n\
Oooooooh...\n\
No ho...\n\
Let her know...\n\
\n\
[Hook]\n\
You did many things\n\
That I liked, that I liked\n\
And you like diamond rings\n\
I can provide, I can provide for you\n\
You made me feel so good\n\
Before I left\n\
On the road\n\
And you deserve your name\n\
On a crown, on a throne\n\
\n"
	},
	{
		title: "High For This  --Weeknd",
		lyrics: "[Verse 1]\n\
You don't know what's in store\n\
But you know what you're here for\n\
Close your eyes, lay yourself beside me (Ooh)\n\
Hold tight for this ride\n\
We don't need no protection\n\
Come alone, we don't need attention\n\
\n\
[Chorus]\n\
Open your hand, take a glass\n\
Don't be scared, I'm right here\n\
Even though, you don't roll\n\
Trust me girl, you wanna be high for this\n\
\n\
[Verse 2]\n\
Take it off, you want it off\n\
'Cause I know what you're feeling\n\
It's okay, girl, I feel it too\n\
Let it be, baby breathe\n\
I swear I'm right here\n\
We'll be good, I promise, we'll be so good, yeah\n\
\n\
[Chorus]\n\
Open your hand, take a glass\n\
Don't be scared, I'm right here\n\
Even though, you don't roll\n\
Trust me girl, you wanna be high for this\n\
[Post-Chorus]\n\
Woah, woah, woah, woah\n\
Woah, woah, woah, woah\n\
Woah, woah, woah, woah\n\
You wanna be high for this\n\
\n\
[Outro]\n\
For this\n\
You wanna be high for this\n\
Ooh, woah\n\
You wanna be high for this, yeah\n\
You wanna be high for this\n\
"
	},
	{
		title : "Bohemian Rhapsody   --Queen",
		lyrics : "[Intro]\n\
Is this the real life? Is this just fantasy?\n\
Caught in a landslide, no escape from reality\n\
Open your eyes, look up to the skies and see\n\
I'm just a poor boy, I need no sympathy\n\
Because I'm easy come, easy go, little high, little low\n\
Any way the wind blows doesn't really matter to me, to me\n\
\n\
[Verse 1]\n\
Mama, just killed a man\n\
Put a gun against his head, pulled my trigger, now he's dead\n\
Mama, life had just begun\n\
But now I've gone and thrown it all away\n\
Mama, ooh, didn't mean to make you cry\n\
If I'm not back again this time tomorrow\n\
Carry on, carry on as if nothing really matters\n\
\n\
[Verse 2]\n\
Too late, my time has come\n\
Sends shivers down my spine, body's aching all the time\n\
Goodbye, everybody, I've got to go\n\
Gotta leave you all behind and face the truth\n\
Mama, ooh (Any way the wind blows)\n\
I don't want to die\n\
I sometimes wish I'd never been born at all\n\
You might also like\n\
Bohemian Rhapsody (Live Aid)\n\
Queen\n\
Bohemian Rhapsody\n\
Queen\n\
Another One Bites the Dust\n\
Queen\n\
[Verse 3]\n\
I see a little silhouetto of a man\n\
Scaramouche, Scaramouche, will you do the Fandango?\n\
Thunderbolt and lightning, very, very fright'ning me\n\
(Galileo) Galileo (Galileo) Galileo, Galileo Figaro magnifico\n\
I'm just a poor boy, nobody loves me\n\
He's just a poor boy from a poor family\n\
Spare him his life from this monstrosity\n\
Easy come, easy go, will you let me go?\n\
Bismillah! No, we will not let you go\n\
(Let him go!) Bismillah! We will not let you go\n\
(Let him go!) Bismillah! We will not let you go\n\
(Let me go) Will not let you go\n\
(Let me go) Will not let you go\n\
(Never let me go) Ah\n\
No, no, no, no, no, no, no\n\
(Oh mamma mia, mamma mia) Mamma mia, let me go\n\
Beelzebub has a devil put aside for me, for me, for me!\n\
\n\
[Verse 4]\n\
So you think you can stone me and spit in my eye?\n\
So you think you can love me and leave me to die?\n\
Oh, baby, can't do this to me, baby!\n\
Just gotta get out, just gotta get right outta here!\n\
\n\
[Outro]\n\
Nothing really matters, anyone can see\n\
Nothing really matters\n\
Nothing really matters to me\n\
Any way the wind blows\n\
"
	},
	{
		 title : "Jesus Of Suburbia   --Green Day",
		 lyrics : "[Part I: Jesus of Suburbia]\n\
\n\
[Verse 1: Billie Joe Armstrong]\n\
I'm the son of rage and love\n\
The Jesus of Suburbia\n\
The bible of \"none of the above\"\n\
On a steady diet of\n\
Soda pop and Ritalin\n\
No one ever died for my\n\
Sins in Hell as far as I can tell\n\
'Least the ones I got away with\n\
\n\
[Chorus: Billie Joe Armstrong]\n\
And there's nothin' wrong with me\n\
This is how I'm supposed to be\n\
In a land of make-believe\n\
That don't believe in me\n\
\n\
[Verse 2: Billie Joe Armstrong]\n\
Get my television fix\n\
Sitting on my crucifix\n\
A living room on my private womb\n\
While the moms and Brads are away\n\
To fall in love and fall in debt\n\
To alcohol and cigarettes\n\
And Mary Jane to keep me insane\n\
Doin' someone else's cocaine\n\
See Green Day Live\n\
Get tickets as low as $40\n\
You might also like\n\
American Idiot\n\
Green Day\n\
Boulevard of Broken Dreams\n\
Green Day\n\
Holiday\n\
Green Day\n\
[Chorus: Billie Joe Armstrong]\n\
And there's nothin' wrong with me\n\
This is how I'm supposed to be\n\
In a land of make-believe\n\
That don't believe in me\n\
\n\
[Drum Solo]\n\
\n\
[Part II: City of the Damned]\n\
\n\
[Verse 3: Billie Joe Armstrong]\n\
At the center of the Earth in the parking lot\n\
Of the 7-Eleven where I was taught\n\
The motto was just a lie\n\
It says \"home is where your heart is,\" but what a shame\n\
'Cause everyone's heart doesn't beat the same\n\
It's beating out of time\n\
\n\
[Chorus: Billie Joe Armstrong & Mike Dirnt]\n\
City of the dead (Hey, hey)\n\
At the end of another lost highway (Hey, hey)\n\
Signs misleading to nowhere\n\
City of the damned (Hey, hey)\n\
Lost children with dirty faces today (Hey, hey)\n\
No one really seems to care\n\
[Verse 4: Billie Joe Armstrong]\n\
I read the graffiti in the bathroom stall\n\
Like the holy scriptures of the shopping mall\n\
And so it seemed to confess\n\
It didn't say much, but it only confirmed\n\
That the center of the Earth is the end of the world\n\
And I could really care less\n\
\n\
[Chorus: Billie Joe Armstrong & Mike Dirnt]\n\
City of the dead (Hey, hey)\n\
At the end of another lost highway (Hey, hey)\n\
Signs misleading to nowhere\n\
City of the damned (Hey, hey)\n\
Lost children with dirty faces today (Hey, hey)\n\
No one really seems to care (Hey)\n\
\n\
[Part III: I Don't Care]\n\
\n\
[Intro: Billie Joe Armstrong]\n\
I don't care if you don't\n\
I don't care if you don't\n\
I don't care if you don't care\n\
I don't care if you don't\n\
I don't care if you don't\n\
I don't care if you don't care\n\
I don't care if you don't\n\
I don't care if you don't\n\
I don't care if you don't care\n\
I don't care if you don't\n\
I don't care if you don't\n\
I don't care if you don't care\n\
I don't care\n\
[Verse 5: Billie Joe Armstrong]\n\
Everyone's so full of shit\n\
Born and raised by hypocrites\n\
Hearts recycled, but never saved\n\
From the cradle to the grave\n\
We are the kids of war and peace\n\
From Anaheim to the Middle East\n\
We are the stories and disciples of\n\
The Jesus of Suburbia\n\
\n\
[Chorus: Billie Joe Armstrong]\n\
Land of make-believe\n\
And it don't believe in me\n\
Land of make-believe (Said now it's, it's another lie)\n\
And I don't believe\n\
\n\
[Outro: Billie Joe Armstrong]\n\
And I don't care (Hoo, hoo, hoo)\n\
I don't care (Hoo, hoo, hoo)\n\
I don't care, ah (Hoo, hoo, hoo)\n\
I don't care, ah (Hoo, hoo, hoo)\n\
I don't care\n\
\n\
[Part IV: Dearly Beloved]\n\
\n\
[Verse 6: Billie Joe Armstrong]\n\
Dearly beloved, are you listening?\n\
I can't remember a word that you were sayin'\n\
Are we demented or am I disturbed?\n\
The space that's in between insane and insecure\n\
\n\
[Refrain: Billie Joe Armstrong]\n\
Ooh, ooh-ooh-ooh\n\
Ooh, ooh-ooh\n\
\n\
[Verse 7: Billie Joe Armstrong]\n\
(Ooh, ooh) Oh therapy, can you please fill the void?\n\
(Ooh, ooh-ooh) Am I retarded or am I just overjoyed?\n\
(Ooh, ooh) Nobody's perfect and I stand accused\n\
(Ooh, ooh-ooh) For lack of a better word and that's my best excuse\n\
Ah\n\
\n\
[Refrain: Billie Joe Armstrong]\n\
Ooh, ooh-ooh-ooh\n\
Ooh, ooh-ooh\n\
\n\
[Part V: Tales of Another Broken Home]\n\
\n\
[Verse 8: Billie Joe Armstrong]\n\
To live and not to breathe\n\
Is to die in tragedy\n\
To run, to run away\n\
To find what you believe\n\
\n\
[Chorus: Billie Joe Armstrong]\n\
And I leave behind\n\
This hurricane of fuckin' lies\n\
\n\
[Verse 9: Billie Joe Armstrong]\n\
I lost my faith to this\n\
This town that don't exist\n\
So I run, I run away\n\
To the light of masochists\n\
\n\
[Chorus: Billie Joe Armstrong]\n\
And I leave behind\n\
This hurricane of fuckin' lies\n\
And I've walked this line\n\
A million and one fuckin' times\n\
But not this time\n\
\n\
[Guitar Solo]\n\
\n\
[Bridge: Billie Joe Armstrong]\n\
I don't feel any shame, I won't apologize\n\
When there ain't nowhere you can go\n\
Runnin' away from pain when you've been victimized\n\
Tales from another broken\n\
\n\
[Outro: Billie Joe Armstrong]\n\
Home\n\
You're leavin'\n\
You're leavin'\n\
You're leavin'\n\
Ah, you're leavin' home\n\
"
	}
]